import type { ReactNode } from 'react';

interface SectionCardProps {
  title: string;
  children: ReactNode;
  actions?: ReactNode;
}

export function SectionCard({ title, children, actions }: SectionCardProps) {
  return (
    <div className="bg-white dark:bg-zinc-800 rounded shadow dark:shadow-zinc-950/30 dark:border dark:border-zinc-700 p-6">
      <div className="flex justify-between items-center mb-4">
        <h2 className="text-lg font-semibold text-gray-900 dark:text-zinc-100">{title}</h2>
        {actions}
      </div>
      {children}
    </div>
  );
}
